export const PATCH_CALENDAR_EVENT_FORM = "patch-calendar-event-form"
export const INCREASE_CALENDAR_EVENT_STEP = "increase-calendar-event-step"
export const DECREASE_CALENDAR_EVENT_STEP = "decrease-calendar-event-step"
export const SET_CALENDAR_EVENT_STEP = "set-calendar-event-step"
export const RESET_CALENDAR_EVENT_FORM = "reset-calendar-event-form"


// WEBPACK FOOTER //
// ./src/state/calendar-event/CalendarEventFormActionTypes.ts